import { render, staticRenderFns } from "./Slice.vue?vue&type=template&id=e06a9440&scoped=true"
import script from "./Slice.vue?vue&type=script&lang=js"
export * from "./Slice.vue?vue&type=script&lang=js"
import style0 from "./Slice.vue?vue&type=style&index=0&id=e06a9440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06a9440",
  null
  
)

export default component.exports